export default theme => ({

  card: {
    margin: theme.spacing.unit * 2,
    width: theme.spacing.unit * 56
  },

  content: {
    padding: theme.spacing.unit * 0.5,
    textAlign: 'left'
  },

  actions: {
    padding: 0,
    height: 'auto',
    justifyContent: 'space-between'
  },

  buttonIcon: {
    marginRight: theme.spacing.unit
  },

  wrapper: {
    padding: theme.spacing.unit * 2
  },

  listItem: {
    cursor: 'default',

    '&:hover': {
      background: 'rgba(0, 0, 0, 0.02)'
    }
  },

  divider: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },

  nopadding: {
    paddingRight: 0
  }

});



// WEBPACK FOOTER //
// ./src/styles/components/ServiceCard.js